// Also known as GA Content Group
import { getSearchParameters } from '../state';
import isZocdocBrand from '../../utils/isZocdocBrand';

export const getZlogPageType = state => {
    const params = getSearchParameters(state);
    const { directoryId, threatLevel } = params;
    if (!isZocdocBrand(directoryId)) {
        return 'SearchBrandedIndex';
    }
    switch (threatLevel) {
        case 'SingleSpec':
            return 'SearchStSpecialy';
        case 'SingleProc':
            return 'SearchStProcedure';
        case 'DoubleIns':
            return 'SearchDtInsurance';
        case 'DoubleLoc':
            return 'SearchDtLocation';
        case 'DoubleLang':
            return 'SearchDtLanguage';
        case 'Triple':
            return 'SearchTt';
        case 'None':
            return 'SearchTypeIn';
        default:
            return 'SearchTypeIn';
    }
};

export const getZlogRollupBucket = state => {
    const params = getSearchParameters(state);
    const { directoryId, threatLevel } = params;
    if (!isZocdocBrand(directoryId)) {
        return 'SearchBrandedIndex';
    } else if (!threatLevel || threatLevel === 'None') {
        return 'SearchTypeIn';
    } else {
        return 'SearchThreat';
    }
};
